'use client';
import WagmiWeb3Provider from '@/components/WagmiWeb3Provider';
import { NewUpdateProvider } from '@/contexts/NewUpdateContext';
import { PlatformDataContextProvider } from '@/contexts/PlatformDataContext';
import { RewardDataContextProvider } from '@/contexts/RewardDataContext';
import UserContextProvider from '@/contexts/User';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConnectKitProvider } from 'connectkit';

const queryClient = new QueryClient();
export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <WagmiWeb3Provider>
      <QueryClientProvider client={queryClient}>
        <ConnectKitProvider>
          <UserContextProvider>
            <NewUpdateProvider>
              <RewardDataContextProvider>
                <PlatformDataContextProvider>
                  {children}
                </PlatformDataContextProvider>
              </RewardDataContextProvider>
            </NewUpdateProvider>
          </UserContextProvider>
        </ConnectKitProvider>
      </QueryClientProvider>
    </WagmiWeb3Provider>
  );
}
